import { FormatMask } from './FormatMask';

const formatSerializedId = (serializedId) => {
  if (serializedId == null || serializedId === '') {
    return '-';
  }
  const formatMask = new FormatMask();
  const number = String(serializedId).replace('@c.us', '');

  const formatted = formatMask.setPhoneFormatMask(number);
  if (formatted == null || formatted === '') {
    return '-';
  }
  return formatted.replace('+55', '🇧🇷');
};

export default formatSerializedId;
